import { useParams } from "react-router-dom";
import FormularioTarea from "./FormularioTarea";
import { useTareasStore } from "../store/api";
import { useEffect, useState } from "react";
import { TareaFormData } from "../DTO/Tarea";
import toast from "react-hot-toast";
import LoadingModal from "../elementos/LoadingModal";

export const DuplicarTarea = () => {
  const id = useParams().id ?? null;
  const { obtenerTareasbyId } = useTareasStore();
  const [tarea, setTarea] = useState<TareaFormData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTarea = async () => {
      try {
        const response = await obtenerTareasbyId(id);
        setTarea({
          ...response,
          id: null,
          fecha: "" 
        })
      } catch (error) {
          toast.error("No se ha podido obtener la tarea");
      } finally {
        setLoading(false);
      }
    };

    fetchTarea();
  }, [id]);
  return (
    <div className="container">
      <LoadingModal show={loading} message="Cargando tarea para duplicar..." />
      <h1
        className="text-center"
        style={{ marginTop: "5%", marginBottom: "5%" }}
      >
        Duplicar tarea
      </h1>
      <FormularioTarea id={null} tarea={tarea} />
    </div>
  );
};
